import { useMemo } from 'react';
import { formatDateTimeVector } from '../../utils/formatDateTimeVector';
export var useDateRangePickerFormattedValue = function useDateRangePickerFormattedValue(_ref, _ref2) {
  var internalValue = _ref.internalValue,
    formatDateTimeRange = _ref.formatDateTimeRange;
  var enableTimePicker = _ref2.enableTimePicker,
    formatDateTime = _ref2.formatDateTime;
  return useMemo(function () {
    if (internalValue.isInfinite()) {
      return '';
    }
    var dateStartFormatted = formatDateTime ? formatDateTime(internalValue.dateStart.convertToLocalDate()) : formatDateTimeVector(internalValue.dateStart, enableTimePicker);
    if (internalValue.isFlat()) {
      return dateStartFormatted;
    }
    var dateEndFormatted = formatDateTime ? formatDateTime(internalValue.dateEnd.convertToLocalDate()) : formatDateTimeVector(internalValue.dateEnd, enableTimePicker);
    return formatDateTimeRange ? formatDateTimeRange(dateStartFormatted, dateEndFormatted) : "".concat(dateStartFormatted, " - ").concat(dateEndFormatted);
  }, [internalValue, enableTimePicker, formatDateTime, formatDateTimeRange]);
};